import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import React from 'react';
import * as styles from './Rating.style';
import { RatingText } from './Rating.style';
export const Rating = (rating) => {
    const { numberOfSale = '0', iconLeft = true, sellerRating = 0, version = 1 } = rating;
    const salesInteger = numberOfSale ? parseInt(numberOfSale.replace(/\s+/g, ''), 10) : 0;
    const rateInteger = sellerRating ? parseInt(sellerRating.replace(/\s+/g, ''), 10) : 0;
    if (salesInteger === 0) {
        return (React.createElement(RatingText, { rating: rating, "data-qa": "sellerNotations" }, "Nouveau vendeur"));
    }
    return (React.createElement(Box, { sx: styles.ratingStyle, "data-qa": "sellerNotations" },
        iconLeft && rateInteger > 0 && React.createElement(StarIcon, { sx: styles.starIcon }),
        version === 1 && (React.createElement(RatingText, { rating: rating },
            !!sellerRating && `${sellerRating}/5`,
            " sur ",
            salesInteger >= 1000 ? `+ de 1 000` : numberOfSale,
            ' ',
            salesInteger === 1 ? `vente` : `ventes`)),
        version === 2 && (React.createElement(RatingText, { rating: rating },
            !!sellerRating && sellerRating,
            " \u2022 ",
            salesInteger >= 1000 ? `+ de 1 000` : numberOfSale,
            " ",
            salesInteger === 1 ? `vente` : `ventes`))));
};
